import { render } from "./Column2.vue?vue&type=template&id=79edeb68"
import script from "./Column2.vue?vue&type=script&lang=js"
export * from "./Column2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__